import React from "react";

import svg from "../../assets/images/icons/exception_flow.svg";

export const ErrorFlowIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Error Flow"}
    />
);
